export var getBreakpoints = function (state) {
    return state.ui.breakpoints;
};
